import { Box, BoxProps } from '@mantine/core';
import React from 'react';

function CustomDivider({ ...props }: BoxProps) {
    return (
        <Box {...props} style={{ borderLeft: "1px solid var(--border-color)" }} />
    )
};

export default CustomDivider;